import {
    IMPERSONATION_RESET_STATE,
    IMPERSONATION_SET_STATE,
} from "./actionType";

export const impersonationSetState = (data) => ({
    type: IMPERSONATION_SET_STATE,
    payload: data,
});

export const impersonationResetState = () => ({
    type: IMPERSONATION_RESET_STATE,
});
